import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React from 'react';
import classNames from 'classnames';
export var DisplayList = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _context;

  var items = props.items,
      parentPrefixCls = props.parentPrefixCls,
      currentIndex = props.currentIndex;
  var itemRef = React.useRef(null);
  var displayListPrefixCls = "".concat(parentPrefixCls, "-list-display");
  var listPrefixCls = "".concat(parentPrefixCls, "-list");

  var renderItems = function renderItems() {
    return _mapInstanceProperty(items).call(items, function (item, index) {
      var opacityClassName = index === currentIndex ? "".concat(listPrefixCls, "-item-not-hidden") : "".concat(listPrefixCls, "-item-hidden");
      return /*#__PURE__*/React.createElement("li", {
        className: classNames("".concat(listPrefixCls, "-item"), opacityClassName),
        key: index,
        ref: itemRef
      }, item);
    });
  };

  return /*#__PURE__*/React.createElement("ul", {
    className: _concatInstanceProperty(_context = "".concat(listPrefixCls, " ")).call(_context, displayListPrefixCls),
    ref: ref
  }, renderItems());
});